/**
 * WebRTC
 *
 *                              A                   |                                       B
 *                                                  |
 *   1.createMedia:got streamA                      | 1.createMedia:got streamB
 *   2.new RTCPeerConnection: APeerConnection       | 2.new RTCPeerConnection: BPeerConnection
 *   3.APeerConnection.createOffer:got offerA       |
 *      APeerConnection.setLocalDescription(offerA) |
 *      send offerA ---> ---> ---> --->        ---> |
 *                                                  | ---> 3.got offerA | offerA = new RTCSessionDescription(offerA);
 *                                                  | BPeerConnection.setRemoteDescription(offerA)
 *                                                  |
 *                                                  |
 *                                                  | 4.BPeerConnection.createAnswer: got answerB
 *                                                  | BPeerConnection.setLocalDescription(answerB)
 *                                                  | <---- send answerB
 *                                                  | 5.got answerB <--- <--- <--- <---
 *                                                  | answerB = new RTCSessionDescription(answerB)
 *                                                  |
 * APeerConnection.setRemoteDescription(answerB)    |
 *                                                  |
 * 6.got candidateA ---> --->  ---> --->            | ---> got candidateA
 *                                                  | BPeerConnection.addIceCandidate(new RTCIceCandidate(candidateA))
 *                                                  |
 *                                                  |
 *                                                  | got candidateB <--- <--- <--- <---
 *                                                  | <--- 6.got candidateB APeerConnection.addIceCandidate(candidateB)
 *                                                  |
 *                                                  |
 *                                                  | 7. APeerConnection.addStream(streamA)
 *                                                  | 7. BPeerConnection.addStream(streamB)
 *                                                  |
 *                              streamA >>>>>>>>>>> |  <<<<< see A
 *                              seeB <<<<<<<<<<<    | <<<<< streamB
 *                                                  |
 *
 */



var _util = require('./Util');
var _logger = _util.tagLogger("Webrtc");

var SDPUtils = require('sdp'); //希望使用 SDPUtils 取代 SDPSection

var DeployMore = require('./mgr/DeployMore').default; //多集群部署 配置文件

var _SDPSection = {
    headerSection: null,

    audioSection: null,
    videoSection: null,

    _parseHeaderSection: function (sdp, audioIndex, videoIndex) {
        var index = audioIndex;

        if(videoIndex === -1){ //保持不变
        }else if(audioIndex === -1){
            index = videoIndex;
        }else{
            index = Math.min(audioIndex, videoIndex);
        }

        if (index >= 0) {
            return sdp.slice(0, index);
        }
        return sdp;
    },

    _parseAudioSection: function (sdp, audioIndex, videoIndex) {
        var index = audioIndex;
        if (index >= 0) {
            return sdp.slice(index, videoIndex < index ? sdp.length : videoIndex);
        }
    },

    _parseVideoSection: function (sdp, audioIndex, videoIndex) {
        var index = videoIndex;
        if (index >= 0) {
            return sdp.slice(index, audioIndex < index ? sdp.length : audioIndex);
        }
    },

    spiltSection: function (sdp) {
        var self = this;

        self._preSDP = sdp;

        var audioIndex = self._preAudioIndex = sdp.indexOf('m=audio');
        var videoIndex = self._preVideoIndex = sdp.indexOf('m=video');

        self.headerSection = self._parseHeaderSection(sdp, audioIndex, videoIndex);
        self.audioSection = self._parseAudioSection(sdp, audioIndex, videoIndex);
        self.videoSection = self._parseVideoSection(sdp, audioIndex, videoIndex);
    },


    setVideoBitrate: function (vbitrate) {
        if(!vbitrate || !this.videoSection){
            return;
        }

        this.videoSection = this.setBitrate(this.videoSection, vbitrate);
    },

    // setVideoMinBitrate: function (vminBitrate) {
    //     if(!vminBitrate || !this.videoSection){
    //         return;
    //     }
    //     //x-google-min-bitrate
    //     this.videoSection = this.videoSection.replace(/(a=fmtp\:\d+\sx-google-min-bitrate=)\d+/g, "$1" + vminBitrate);
    // },
    setVideoMinBitrate: function (minBitrate) {
        this.setAllFmtpBitrate({"x-google-min-bitrate": minBitrate});
        // this.setAllFmtpBitrate({
        //     "x-google-min-bitrate": minBitrate,
        //     "x-google-start-bitrate": minBitrate + 100,
        //     "x-google-max-bitrate": minBitrate + 100000,
        // });
    },
    setVideoMaxBitrate: function (maxBitrate) {
        this.setAllFmtpBitrate({"x-google-max-bitrate": maxBitrate});
    },
    setVideoStartBitrate: function (startBitrate) {
        this.setAllFmtpBitrate({"x-google-start-bitrate": startBitrate});
    },
    setAllFmtpBitrate: function setFmtpBitrate (map) {
        if(!this.videoSection){
            return;
        }

        // var vp8H264H265=[];
        // this.videoSection.replace(/a=rtpmap\:(\d+)\s+(VP8|H264|H265)[^\r\n]+([\r\n]+)/g, function (all, code, name) {
        //     //console.log(code, name);
        //     vp8H264H265.push(code);
        // });

        var fields = {};
        Object.keys(map).forEach(function(fmtpName) {
            var bitrate = map[fmtpName];
            var field = fmtpName + "=" + bitrate;
            var regex = new RegExp('(a=fmtp\\:\\d+\\s\\S*;?)(' + fmtpName + '=\\d+)(;?\\S*)', 'g');

            fields[fmtpName] = {field: field, regex: regex}
        });

        //(?:' + vp8H264H265.join('|') + '
        ///(a=fmtp\:\d+)[^\r\n]+)([\r\n]+)/g
        //new RegExp('(a=fmtp\\:(?:' + vp8H264H265.join('|') + ')[^\\r\\n]+)([\\r\\n]+)', 'g')

        this.videoSection = this.videoSection.replace(/(a=fmtp\:\d+[^\r\n]+)([\r\n]+)/g, function (all, fmtp, enter) {
            if(fmtp.indexOf("apt=") >= 0){
                return all;
            }

            Object.keys(fields).forEach(function(fmtpName){
                var fieldAndRegex = fields[fmtpName];

                var regex = fieldAndRegex.regex;
                var field = fieldAndRegex.field;
                var replacedFmtp = fmtp.replace(regex, function ($$, $1, $2, $3) {
                    return $1 + field + $3;
                });

                if(replacedFmtp.indexOf(fmtpName) < 0){ //没有包含
                    if(!replacedFmtp.endsWith(';')){
                        replacedFmtp += ";"
                    }
                    fmtp = replacedFmtp + field;
                }else{
                    fmtp = replacedFmtp;
                }
            });

            return fmtp + enter;
        });
    },
    setFmtpBitrate: function setFmtpBitrate (fmtpName, bitrate) {
        if(!bitrate || !this.videoSection){
            return;
        }

        var field = fmtpName + "=" + bitrate;
        var regex = new RegExp('(a=fmtp\\:\\d+\\s\\S*;?)(' + fmtpName + '=\\d+)(;?\\S*)', 'g');
        this.videoSection = this.videoSection.replace(/(a=fmtp\:\d+[^\r\n]+)([\r\n]+)/g, function (all, fmtp, enter) {
            var replacedFmtp = fmtp.replace(regex, function ($$, $1, $2, $3) {
                return $1 + field + $3;
            });

            if(replacedFmtp.indexOf(fmtpName) < 0){ //没有包含
                if(!replacedFmtp.endsWith(';')){
                    replacedFmtp += ";"
                }
                replacedFmtp = replacedFmtp + field;
            }

            return replacedFmtp + enter;
        });
    },

    setAudioBitrate: function (abitrate) {
        if(!abitrate || !this.audioSection){
            return;
        }

        this.audioSection = this.setBitrate(this.audioSection, abitrate);
    },

    setBitrate0: function (section, bitrate) {
        section = section.replace(/(b=)(?:AS|TIAS)(\:)\d+/g, "$1AS$2" + bitrate);
        if(section.indexOf('b=AS') < 0){
            section = section.replace(/(m=(?:audio|video)[^\r\n]+)([\r\n]+)/g, "$1$2b=AS:" + bitrate + "$2")
        }
        return section;
    },

    setBitrate: function (section, bandwidth) {
        let modifier = 'AS';
        if (emedia.isFirefox) {
            bandwidth = (bandwidth >>> 0) * 1000;
            modifier = 'TIAS';
        }
        section = section.replace(/(b=)(?:AS|TIAS)(\:)\d+/g, "$1" + modifier + "$2" + bandwidth);
        if(section.indexOf('b=' + modifier + ':') < 0){ //没有b行
            if(section.indexOf('c=IN ') < 0){ // 没有C行
                section = section.replace(/(m=(?:audio|video)[^\r\n]+)([\r\n]+)/g, "$1$2b=" + modifier  + ":" + bandwidth + "$2")
            }else{
                // insert b= after c= line.
                section = section.replace(/c=IN ([^\r\n]+)([\r\n]+)/, 'c=IN $1$2b=' + modifier + ':' + bandwidth + '$2');
            }
        }
        return section;
    },

    updateVideoSection: function (regx, oper) {
        var self = this;

        if(!self.videoSection){
            return;
        }

        self.videoSection = self.videoSection.replace(regx, oper);
    },

    updateAudioSection: function (regx, oper) {
        var self = this;

        if(!self.audioSection){
            return;
        }

        self.audioSection = self.audioSection.replace(regx, oper);
    },

    updateVideoSendonly: function () {
        var self = this;

        if(!self.videoSection){
            return;
        }

        self.videoSection = self.videoSection.replace(/sendrecv/g, "sendonly");
    },

    updateVideoRecvonly: function () {
        var self = this;

        if(!self.videoSection){
            return;
        }

        self.videoSection = self.videoSection.replace(/sendrecv/g, "recvonly");
    },

    updateAudioSendonly: function () {
        var self = this;

        if(!self.audioSection){
            return;
        }

        self.audioSection = self.audioSection.replace(/sendrecv/g, "sendonly");
    },

    updateAudioRecvonly: function () {
        var self = this;

        if(!self.audioSection){
            return;
        }

        self.audioSection = self.audioSection.replace(/sendrecv/g, "recvonly");
    },

    updateACodes: function (acodes) {
        var self = this;

        if(!acodes){
            return;
        }
        if(!self.audioSection){
            return;
        }

        if(typeof acodes === "string"){
            var arr = [];
            arr.push(acodes);
            acodes = arr;
        }

        var vcodeMap = {};
        var regexp = /a=rtpmap:(\d+) ([A-Za-z0-9]+)\/.*/ig;
        var arr = self._parseLine(self.audioSection, regexp);
        for(var i = 0; i < arr.length; i++) {
            var codeNum = arr[++i];
            var code = arr[++i];
            vcodeMap[code] = codeNum;
        }

        var numCodes = [];
        for(var i = 0; i < acodes.length; i++){
            var supportVCode = vcodeMap[acodes[i]];
            supportVCode && numCodes.push(supportVCode);
        }
        if(numCodes.length == 0){
            if(self._webrtc){
                _logger.warn("Not found acodes map", acodes, self._webrtc._rtcId, self._webrtc.__id);
            }else{
                _logger.warn("Not found acodes map", acodes);
            }
        }

        var codeLineLastIndex = self.audioSection.indexOf('\r');
        var codeLine = self.audioSection.substring(0, codeLineLastIndex);

        var fields = codeLine.split(' ');

        Array.prototype.push.apply(numCodes, fields.slice(3));

        var newNumCodes = [];
        var _map = {};
        _util.forEach(numCodes, function (index, ele) {
            if(newNumCodes.length == 0){
                newNumCodes.push(ele);
                _map[ele] = true;
            } else {
                if(!_map[ele]){
                    newNumCodes.push(ele);
                    _map[ele] = true;
                }
            }
        });
        //alert(numCodes.join(' '));

        //fields.splice(3, 0, numCodes);
        fields.splice(3, fields.length - 3, newNumCodes.join(' '));

        codeLine = fields.join(' ');
        //_logger.info(codeLine);
        if(self._webrtc){
            _logger.warn(codeLine, self._webrtc._rtcId, self._webrtc.__id);
        }

        self.audioSection = codeLine + self.audioSection.substring(codeLineLastIndex);
    },

    updateVCodes: function (vcodes) {
        var self = this;

        if(!vcodes){
            return;
        }
        if(!self.videoSection){
            return;
        }

        if(typeof vcodes === "string"){
            var arr = [];
            arr.push(vcodes);
            vcodes = arr;
        }

        var vcodeMap = {};
        var regexp = /a=rtpmap:(\d+) ([A-Za-z0-9]+)\/.*/ig;
        var arr = self._parseLine(self.videoSection, regexp);
        for(var i = 0; i < arr.length; i++) {
            var codeNum = arr[++i];
            var code = arr[++i];
            vcodeMap[code] = codeNum;
        }

        //H264
        //if(/Firefox/.test(navigator.userAgent) || /Chrome/.test(navigator.userAgent)){ //a=fmtp:126 profile-level-id=42e01f;level-asymmetry-allowed=1;packetization-mode=1
        var h264_regexp = /a=fmtp:(\d+) .*profile-level-id=42e01f;?.*/ig;
        var h264_arr = self._parseLine(self.videoSection, h264_regexp);

        if(h264_arr && h264_arr.length >= 2){
            vcodeMap['H264'] = h264_arr[1];
        }
        //}

        var numCodes = []
        for(var i = 0; i < vcodes.length; i++){
            var supportVCode = vcodeMap[vcodes[i]];
            supportVCode && numCodes.push(supportVCode);
        }
        if(numCodes.length == 0){
            if(self._webrtc){
                _logger.warn("Not found vcodes map", vcodes, self._webrtc._rtcId, self._webrtc.__id);
            }else{
                _logger.warn("Not found vcodes map", vcodes);
            }
        }

        var codeLineLastIndex = self.videoSection.indexOf('\r');
        var codeLine = self.videoSection.substring(0, codeLineLastIndex);

        var fields = codeLine.split(' ');

        Array.prototype.push.apply(numCodes, fields.slice(3));

        var newNumCodes = [];
        var _map = {};
        _util.forEach(numCodes, function (index, ele) {
            if(newNumCodes.length == 0){
                newNumCodes.push(ele);
                _map[ele] = true;
            } else {
                if(!_map[ele]){
                    newNumCodes.push(ele);
                    _map[ele] = true;
                }
            }
        });
        //alert(numCodes.join(' '));

        //fields.splice(3, 0, numCodes);
        fields.splice(3, fields.length - 3, newNumCodes.join(' '));

        codeLine = fields.join(' ');
        //_logger.info(codeLine);
        if(self._webrtc){
            _logger.warn(codeLine, self._webrtc._rtcId, self._webrtc.__id);
        }

        self.videoSection = codeLine + self.videoSection.substring(codeLineLastIndex);
    },

    removeSSRC: function (section) {
        var arr = [];

        var _arr = section.split(/a=ssrc:[^\n]+/g);
        for (var i = 0; i < _arr.length; i++) {
            _arr[i] != '\n' && arr.push(_arr[i]);
        }
        // arr.push('');

        return arr.join('\n');
    },

    removeField_msid: function (section) {
        var arr = [];

        var _arr = section.split(/a=msid:[^\n]+/g);
        for (var i = 0; i < _arr.length; i++) {
            _arr[i] != '\n' && arr.push(_arr[i]);
        }
        // arr.push('');

        section = arr.join('\n');
        arr = [];

        _arr = section.split(/[\n]+/g);
        for (var i = 0; i < _arr.length; i++) {
            (_arr[i] != '\n') && arr.push(_arr[i]);
        }

        return arr.join('\n');
    },

    updateHeaderMsidSemantic: function (wms) {

        var self = this;

        var line = "a=msid-semantic: WMS " + wms;

        var _arr = self.headerSection.split(/a=msid\-semantic: WMS.*/g);
        var arr = [];
        switch (_arr.length) {
            case 1:
                arr.push(_arr[0]);
                break;
            case 2:
                arr.push(_arr[0]);
                arr.push(line);
                arr.push('\n');
                break;
            case 3:
                arr.push(_arr[0]);
                arr.push(line);
                arr.push('\n');
                arr.push(_arr[2]);
                arr.push('\n');
                break;
        }

        return self.headerSection = arr.join('');
    },

    updateAudioSSRCSection: function (ssrc, cname, msid, label) {
        var self = this;

        self.audioSection && (self.audioSection = self.removeSSRC(self.audioSection));
        self.audioSection && (self.audioSection = self.removeField_msid(self.audioSection));
        self.audioSection && (self.audioSection = self.audioSection + self.ssrcSection(ssrc, cname, msid, label));
    },


    updateVideoSSRCSection: function (ssrc, cname, msid, label) {
        var self = this;

        self.videoSection && (self.videoSection = self.removeSSRC(self.videoSection));
        self.videoSection && (self.videoSection = self.removeField_msid(self.videoSection));
        self.videoSection && (self.videoSection = self.videoSection + self.ssrcSection(ssrc, cname, msid, label))
    },

    getUpdatedSDP: function (audioVideo) {
        var self = this;

        // if(self._preAudioIndex < 0 || self._preVideoIndex < 0){
        //     return this._preSDP;
        // }
        //
        // audioVideo = (audioVideo === true || audioVideo === undefined);
        // var sdpAudioVideo = self._preAudioIndex < self._preVideoIndex;
        //
        // if(audioVideo == sdpAudioVideo){
        //     return this._preSDP;
        // }

        if(audioVideo === undefined || audioVideo == null){
            audioVideo = self._preAudioIndex < self._preVideoIndex;
        }

        var videoMid;
        self.videoSection && self.videoSection.replace(/a=mid:([^\r\n]+)/, function(match, p1){
            videoMid = p1;
            return match;
        });

        var audioMid;
        self.audioSection && self.audioSection.replace(/a=mid:([^\r\n]+)/, function(match, p1){
            audioMid = p1;
            return match;
        });

        var sdp;
        if(audioVideo){
            var bundleLine = ["a=group:BUNDLE"];
            self.audioSection && bundleLine.push(audioMid);
            self.videoSection && bundleLine.push(videoMid);

            sdp = self.headerSection.replace(/a=group:BUNDLE [^\r\n]+/, bundleLine.join(" "));

            self.audioSection && (sdp += self.audioSection);
            self.videoSection && (sdp += self.videoSection);
        }else{
            var bundleLine = ["a=group:BUNDLE"];
            self.videoSection && bundleLine.push(videoMid);
            self.audioSection && bundleLine.push(audioMid);

            sdp = self.headerSection.replace(/a=group:BUNDLE [^\r\n]+/, bundleLine.join(" "));

            self.videoSection && (sdp += self.videoSection);
            self.audioSection && (sdp += self.audioSection);
        }

        return sdp;
    },

    parseMsidSemantic: function (header) {
        var self = this;

        var regexp = /a=msid\-semantic:\s*WMS (\S+)/ig;
        var arr = self._parseLine(header, regexp);

        arr && arr.length == 2 && (self.msidSemantic = {
            line: arr[0],
            WMS: arr[1]
        });

        return self.msidSemantic;
    },

    ssrcSection: function (ssrc, cname, msid, label) {
        var lines = [
            'a=ssrc:' + ssrc + ' cname:' + cname,
            'a=ssrc:' + ssrc + ' msid:' + msid + ' ' + label,
            'a=ssrc:' + ssrc + ' mslabel:' + msid,
            'a=ssrc:' + ssrc + ' label:' + label,
            ''
        ];

        return lines.join('\n');
    },

    parseSSRC: function (section) {
        var self = this;

        var regexp = new RegExp("a=(ssrc):(\\d+) (\\S+):(\\S+)", "ig");

        var arr = self._parseLine(section, regexp);
        if (arr) {
            var ssrc = {
                lines: [],
                updateSSRCSection: self.ssrcSection
            };

            for (var i = 0; i < arr.length; i++) {
                var e = arr[i];
                if (e.indexOf("a=ssrc") >= 0) {
                    ssrc.lines.push(e);
                } else {
                    switch (e) {
                        case 'ssrc':
                        case 'cname':
                        case 'msid':
                        case 'mslabel':
                        case 'label':
                            ssrc[e] = arr[++i];
                    }
                }
            }

            return ssrc;
        }
    },

    _parseLine: function (str, regexp) {
        var arr = [];

        var _arr;
        while ((_arr = regexp.exec(str)) != null) {
            for (var i = 0; i < _arr.length; i++) {
                arr.push(_arr[i]);
            }
        }

        if (arr.length > 0) {
            return arr;
        }
    }
};

var SDPSection = function (sdp, webrc) {
    _util.extend(this, _SDPSection);
    this._webrtc = webrc;
    this.spiltSection(sdp);
};

SDPSection.isAudioVideo = function (sdp) {
    var audioIndex = sdp.indexOf('m=audio');
    var videoIndex = sdp.indexOf('m=video');

    return audioIndex < videoIndex;
}

SDPSection.isVideoPreAudio = function (sdp) {
    var audioIndex = sdp.indexOf('m=audio');
    var videoIndex = sdp.indexOf('m=video');

    return audioIndex >= 0 && videoIndex>=0 && videoIndex < audioIndex;
}

var __rtc_globalCount = emedia.__rtc_globalCount = 0;

/**
 * Abstract
 * {
 *   onIceStateChange:
 *   onIceCandidate:
 *   onGotRemoteStream:
 *
 *   createRtcPeerConnection:
 *   createOffer:
 *   createPRAnswer:
 *   createAnswer:
 *   addIceCandidate:
 *   close:
 *   iceState:
 *
 *   setLocalStream:
 *   getRtcId:
 * }
 *
 */
/**
 * ICE 通道失败：
 * 1.set sdp 失败
 * 2.set cands 失败
 * 但最终都是 ice fail
 *
 *
 * onSetSessionDescriptionError
 * onCreateSessionDescriptionError
 * onAddIceCandidateError
 *
 * onIceStateChange  ice fail
 *
 */
var _WebRTC = _util.prototypeExtend({
    closed: false,
    sdpConstraints: {
        'mandatory': {
            'OfferToReceiveAudio': true,
            'OfferToReceiveVideo': true
        }
    },

    /**
     * offerToReceiveAudio false sendonly, or sendrecv
     * offerToReceiveVideo false sendonly, or sendrecv
     *
     */
    offerOptions: {
        offerToReceiveAudio: true,
        offerToReceiveVideo: true,
        //voiceActivityDetection: false
    },

    optimalVideoCodecs: null,
    optimalAudioCodecs: null,

    __init__: function () {
        var self = this;

        self._rtcId || (self._rtcId = "RTC" + (__rtc_globalCount++));
        self.__id = "_i_" + (__rtc_globalCount++);

        self.__setRemoteSDP = false;
        self.__tmpRemoteCands = [];
        self.__tmpLocalCands = [];
        self._rtcPeerConnection = null;

        self.cctx = self.__id;

        emedia && emedia.config && emedia.config.forceUseVideoCodecs && emedia.config.forceUseVideoCodecs.length > 0
            && (self.optimalVideoCodecs = emedia.config.forceUseVideoCodecs);
        emedia && emedia.config && emedia.config.forceUseAudioCodecs && emedia.config.forceUseAudioCodecs.length > 0
            && (self.optimalAudioCodecs = emedia.config.forceUseAudioCodecs);
        emedia && emedia.config && (typeof emedia.config.forceVideoBitrate === "number")
            && (self.vbitrate = emedia.config.forceVideoBitrate);
        emedia && emedia.config && (typeof emedia.config.forceMinVideoBitrate === "number")
            && (self.vminBitrate = emedia.config.forceMinVideoBitrate);
        emedia && emedia.config && (typeof emedia.config.forceAudioBitrate === "number")
            && (self.abitrate = emedia.config.forceAudioBitrate);

        _logger.info("Webrtc created. optimal video codecs:", self.optimalVideoCodecs,
            "audio codecs:", self.optimalAudioCodecs,
            "vbitrate:", self.vbitrate,
            "vminBitrate:", self.vminBitrate,
            "abitrate:", self.abitrate, self._rtcId, self.__id);
    },

    getRtcId: function(){
        return this._rtcId;
    },

    iceState: function () {
        var self = this;
        return self._rtcPeerConnection.iceConnectionState;
    },

    setSubArgs: function (subArgs) {
        var self = this;
        self.subArgs = subArgs;
    },

    getReceiversOfPeerConnection: function () {
        var self = this;

        if(!self._rtcPeerConnection){
            return;
        }

        if(self._rtcPeerConnection.iceConnectionState == 'closed'){
            return;
        }

        return self._rtcPeerConnection.getReceivers();
    },

    updateRemoteBySubArgs: function () {
        var self = this;

        if(!self.subArgs){
            return;
        }
        if(!self._remoteStream){
            return;
        }

        emedia.enableVideoTracks(self._remoteStream, !(self.subArgs && self.subArgs.subSVideo === false));
        emedia.enableAudioTracks(self._remoteStream, !(self.subArgs && self.subArgs.subSAudio === false));

        _logger.info("enable tracks remote stream", self._remoteStream, self.subArgs, self._rtcId, self.__id,  self.closed);
    },

    createRtcPeerConnection: function (iceServerConfig) {
        var self = this;
        _logger.debug('begin create peer connection ......', self._rtcId, self.__id,  self.closed);

        iceServerConfig || (iceServerConfig = self.iceServerConfig);

        if (iceServerConfig || emedia.isEdge){ //reduce icecandidate number:add default value
            iceServerConfig || (iceServerConfig = {});
            !iceServerConfig.iceServers && (iceServerConfig.iceServers = []);

            iceServerConfig.rtcpMuxPolicy = "require";
            iceServerConfig.bundlePolicy = "max-bundle";

            // iceServerConfig.iceTransportPolicy = 'relay';
            if(iceServerConfig.relayOnly){
                iceServerConfig.iceTransportPolicy = 'relay';
            }
        } else {
            iceServerConfig = null;
        }

        // iceServerConfig = {
        //     capAudio: true,
        //     capVideo: true,
        //     iceServers:[{
        //         credential: "+F34cGoWeMmwa+XtvibM7dr4Ccc=",
        //         url: "turn:101.200.76.93:3478",
        //         username: "hx-demo#chatdemoui_yss000@hx.com/webim_device_uuid%179310420104847360:1506431735"
        //     }],
        //     recvAudio: true,
        //     recvVideo: true,
        //     relayOnly: false,
        // };

        if(emedia && emedia.config && typeof emedia.config.reconfigRTCConfiguration === 'function'){
            iceServerConfig = emedia.config.reconfigRTCConfiguration(iceServerConfig);
        }

        if(emedia.config.useDeployMore) {// 读取rtcconfig 替换trun url 如果开启了使用多集群
            if(!emedia.mgr.rtc_url_config){// 1v1 第一次呼叫可能还没请求 config.json
                emedia.mgr.rtc_url_config = new DeployMore(emedia.config.rtcConfigUrl || '');
            }
            if(
                iceServerConfig && iceServerConfig.iceServers
            ) { // 多人时 iceServerConfig 为 null
                iceServerConfig = emedia.mgr.rtc_url_config.replace_trun_url(iceServerConfig);
            }
        }

        _logger.info('create pc, set config:', iceServerConfig, self._rtcId, self.__id,  self.closed);
        
        var rtcPeerConnection = self._rtcPeerConnection = new RTCPeerConnection(iceServerConfig);
        rtcPeerConnection.__peerId = self._rtcId;
        _logger.debug('created local peer connection object', rtcPeerConnection, self._rtcId);


        rtcPeerConnection.onicecandidate = function (event) {
            var candidate = event.candidate;

            //reduce icecandidate number: don't deal with tcp, udp only
            if (event.type == "icecandidate"
                && ((!candidate)
                    || (typeof candidate.protocol === 'string' && candidate.protocol.toLowerCase() === 'tcp')
                    || / TCP /.test(candidate.candidate))) {
                _logger.debug("On ICE candidate: drop", candidate, self._rtcId, self.__id,  self.closed);
                return;
            }

            if(!candidate.candidate){
                _logger.error("Not found candidate. candidate is error");
                throw "Not found candidate. candidate is error,";
            }

            candidate.cctx = self.cctx;
            if(!self.__setRemoteSDP){
                (self.__tmpLocalCands || (self.__tmpLocalCands = {})).push(candidate);
                _logger.debug('On ICE candidate ok: but tmp buffer caused by not set remote sdp: ', candidate,
                    self._rtcId, self.__id,  self.closed);
                return;
            }else{
                _logger.debug('On ICE candidate ok: ', candidate, self._rtcId, self.__id,  self.closed);
            }
            self._onIceCandidate(candidate);
        };

        self.lastIceConnectionState = '';
        function stateChange(event) {
            _logger.info("states: connectionState", rtcPeerConnection.connectionState, ", iceConnectionState",
                rtcPeerConnection.iceConnectionState, "@", self._rtcId, self.__id, self.closed);
            try {
                //var theState = rtcPeerConnection.connectionState || rtcPeerConnection.iceConnectionState;
                var theState = rtcPeerConnection.iceConnectionState || rtcPeerConnection.connectionState;
                if('failed' == rtcPeerConnection.connectionState
                    || 'failed' == rtcPeerConnection.iceConnectionState){
                    theState = "failed";
                }
                if (self.lastIceConnectionState !== theState) {
                    self.lastIceConnectionState = theState;
                    self.onIceStateChange(theState);
                }
            } finally {}
        }

        rtcPeerConnection.onconnectionstatechange = stateChange.bind(self);
        rtcPeerConnection.onicestatechange =  stateChange.bind(self);
        rtcPeerConnection.oniceconnectionstatechange =  stateChange.bind(self);
        rtcPeerConnection.onsignalingstatechange = function (event) {
            _logger.info("states: signaling", rtcPeerConnection.signalingState, "@", self._rtcId, self.__id,  self.closed);
        }

        if(rtcPeerConnection.ontrack === null){
            self._onTrack && (rtcPeerConnection.ontrack = function (event) {
                self._onTrack(event);
            });
        }

        rtcPeerConnection.onaddstream = function (event) {
            self._onGotRemoteStream(event);
        };
    },

    addTrack: function(tracks, stream){
        var self = this;

        tracks.forEach(function(track) {
            self._rtcPeerConnection.addTrack(track, stream);
            _logger.debug('Added track(', track.id, track.kind, track.label,') of stream(', stream.id, ') to RtcPeerConnection',
                 self._rtcId, self.__id, self.closed);
        });
    },
    setLocalStream: function (localStream) {
        var self = this;

        self._localStream = localStream;

        if(self._rtcPeerConnection.addTrack){
            localStream.getTracks().forEach(function(track) {
                self._rtcPeerConnection.addTrack(track, localStream);
                _logger.debug('Added track(', track.enabled, track.id, track.kind, track.label,') of localStream(', localStream.id, ') to RtcPeerConnection',
                    self._rtcId, self.__id, self.closed);
            });
        }else{
            self._rtcPeerConnection.addStream(localStream);

            var videoTracks = localStream.getVideoTracks();
            var audioTracks = localStream.getAudioTracks();

            if (videoTracks && videoTracks.length > 0) {
                _logger.debug('RtcPeerConnection video: ',
                    videoTracks[0].enabled, videoTracks[0].id, videoTracks[0].kind, videoTracks[0].label,
                    self._rtcId, self.__id, self.closed);
            }
            if (audioTracks && audioTracks.length > 0) {
                _logger.debug('RtcPeerConnection audio: ',
                    audioTracks[0].enabled, audioTracks[0].id, audioTracks[0].kind, audioTracks[0].label,
                    self._rtcId, self.__id, self.closed);
            }
        }
        _logger.debug('Added local stream to RtcPeerConnection',
            localStream.id, localStream.active, self._rtcId, self.__id, this.closed);
    },

    removeStream: function (mediaStream) {
        this._rtcPeerConnection.removeStream(mediaStream);
        _logger.debug('Remove stream from RtcPeerConnection', mediaStream, self._rtcId, self.__id, this.closed);
    },

    getLocalStream: function () {
        return this._localStream;
    },
    getRemoteStream: function () {
        return this._remoteStream;
    },

    createOffer: function (onCreateOfferSuccess, onCreateOfferError) {
        //offerToReceiveAudio = false时，chrome没有video段；safari却这个块。需要将sendrecv改为sendonly
        //由于手机没有视频发布时，sdp中有video字段，而 web以offerToReceiveVideo = false去订阅时，导致订阅流中没有video块，会引发重协商。进而导致 始终无法看到对方视频
        //所以 订阅流时 无论offerToReceiveVideo = false，都生成offer sdp；其中都有video块。即 offerToReceiveVideo = true；但要将sdp修改为recvonly
        
        // if(self.subArgs){
        //     c_offerOptions = {
        //         offerToReceiveAudio: true,
        //         offerToReceiveVideo: true
        //     }
        // }
        
        _logger.info('start create offer... self.offerOption str', JSON.stringify(this.offerOptions))
        _logger.info('start create offer... self.offerOption', this.offerOptions)
        
        var self = this;

        var offerOptions_changeless = _util.extend({}, self.offerOptions); // 固定下来的 options， createoffer 异步后不固化，可能会变
                
        let offerOptions = self.subArgs ? {offerToReceiveAudio: true, offerToReceiveVideo: true} : 
                            JSON.parse(JSON.stringify(self.offerOptions)); //  createoffer options

        return self._rtcPeerConnection.createOffer(offerOptions).then(
            function (desc) {

                _logger.info('original offer sdp', desc)

                self.offerDescription = desc;

                if(emedia.isEdge){
                    desc.sdp = desc.sdp.replace(/profile-level-id=[^;]+/, "profile-level-id=42e01f");
                }
                if(emedia.isFirefox){
                    //需要交换 cand answer
                    self.fireFoxOfferVideoPreAudio = self.__offerVideoPreAudio = SDPSection.isVideoPreAudio(desc.sdp);
                }else{
                    self.__offerVideoPreAudio = SDPSection.isVideoPreAudio(desc.sdp); // video在audio前时，xswitch的answer是 audio在前。set answer时需要 变换answer
                }

                desc.sdp = desc.sdp.replace(/m=video 0/g, "m=video 9");
                _logger.warn("setLocalDescription. modify offer. if 'm=video 0' -> 'm=video 9'; if H264, 'profile-level-id=42e01f'", self._rtcId, self.__id);

                if((self.optimalVideoCodecs && self.optimalVideoCodecs.length > 0) //数组或字符串
                    || (self.optimalAudioCodecs && self.optimalAudioCodecs.length > 0) //数组或字符串
                    // || (self.offerOptions && (self.offerOptions.offerToReceiveVideo === false || self.offerOptions.offerToReceiveAudio === false))
                    || (offerOptions_changeless && (offerOptions_changeless.offerToReceiveVideo === false || offerOptions_changeless.offerToReceiveAudio === false))
                ){
                    var sdpSection = new SDPSection(desc.sdp, self);
                    self.optimalVideoCodecs && sdpSection.updateVCodes(self.optimalVideoCodecs);
                    self.optimalAudioCodecs && sdpSection.updateACodes(self.optimalAudioCodecs);

                    // self.offerOptions && self.offerOptions.offerToReceiveVideo === false
                    //     && sdpSection.updateVideoSection(/a=sendrecv|a=recvonly/g, "a=sendonly");
                    // self.offerOptions && self.offerOptions.offerToReceiveAudio === false
                    //     && sdpSection.updateAudioSection(/a=sendrecv|a=recvonly/g, "a=sendonly");

                    offerOptions && offerOptions_changeless.offerToReceiveVideo === false
                        && sdpSection.updateVideoSection(/a=sendrecv|a=recvonly/g, "a=sendonly");
                    offerOptions && offerOptions_changeless.offerToReceiveAudio === false
                        && sdpSection.updateAudioSection(/a=sendrecv|a=recvonly/g, "a=sendonly");

                    desc.sdp = sdpSection.getUpdatedSDP(); //保持顺序
                }

                _logger.debug('setLocalDescription start', self._rtcId, self.__id,  self.closed, self.optimalVideoCodecs, self.optimalAudioCodecs);
                if(emedia.config.useDTX){
                    // 1. 先删除 带 CN/ 的行
                    desc.sdp = desc.sdp.replace(/a=rtpmap:(.*)CN\/(.*)\r\n/g, '')
                    // 2. 拿到 音频编码的 数字
                    let num = desc.sdp.match(/a=rtpmap:(.*)\sopus/)[1];
                    // 3. 在a=fmtp:${num} 结尾添加 ;usedtx=1
                    desc.sdp = desc.sdp.replace(new RegExp(`a=fmtp:${num}(.*)\\r\\n`),`a=fmtp:${num}$1;usedtx=1\r\n`);
                }
                self._rtcPeerConnection.setLocalDescription(desc).then(
                    self._onSetLocalSessionDescriptionSuccess.bind(self),
                    self._onSetSessionDescriptionError.bind(self, desc)
                ).then(function () {
                    desc.cctx = self.cctx;
                    (onCreateOfferSuccess || self.onCreateOfferSuccess.bind(self))(desc);
                });
            },
            (onCreateOfferError || self._onCreateSessionDescriptionError.bind(self, offerOptions))
        );
    },

    createPRAnswer: function (onCreatePRAnswerSuccess, onCreatePRAnswerError) {
        var self = this;

        _logger.info(' createPRAnswer start',  self.closed, self.sdpConstraints);
        // Since the 'remote' side has no media stream we need
        // to pass in the right constraints in order for it to
        // accept the incoming offer of audio and video.
        return self._rtcPeerConnection.createAnswer(self.sdpConstraints).then(
            function (desc) {
                _logger.debug('_____________PRAnswer ', desc.sdp, self._rtcId, self.__id,  self.closed);//_logger.debug('from :\n' + desc.sdp);

                desc.type = "pranswer";
                desc.sdp = desc.sdp.replace(/a=recvonly/g, 'a=inactive');

                var sdpSection = new SDPSection(desc.sdp, self);
                self.optimalVideoCodecs && sdpSection.updateVCodes(self.optimalVideoCodecs);
                self.optimalAudioCodecs && sdpSection.updateACodes(self.optimalAudioCodecs);

                desc.sdp = sdpSection.getUpdatedSDP(); //保持顺序

                self.__prAnswerDescription = desc;

                _logger.debug('inactive PRAnswer ', desc.sdp, self._rtcId, self.__id,  self.closed);//_logger.debug('from :\n' + desc.sdp);
                _logger.debug('setLocalDescription start', desc, self._rtcId, self.__id,  self.closed);

                self._rtcPeerConnection.setLocalDescription(desc).then(
                    self._onSetLocalSessionDescriptionSuccess.bind(self),
                    self._onSetSessionDescriptionError.bind(self, desc)
                ).then(function () {
                    sdpSection.updateHeaderMsidSemantic("MS_0000");
                    sdpSection.updateAudioSSRCSection(1000, "CHROME0000", "MS_0000", "LABEL_AUDIO_1000");
                    sdpSection.updateVideoSSRCSection(2000, "CHROME0000", "MS_0000", "LABEL_VIDEO_2000");

                    desc.sdp = sdpSection.getUpdatedSDP();

                    _logger.debug('Send PRAnswer ', desc.sdp, self._rtcId, self.__id,  self.closed);//_logger.debug('from :\n' + desc.sdp);

                    self.cctx && (desc.cctx = self.cctx);
                    (onCreatePRAnswerSuccess || self.onCreatePRAnswerSuccess.bind(self))(desc);
                });
            },
            (onCreatePRAnswerError || self._onCreateSessionDescriptionError.bind(self, self.sdpConstraints))
        );
    },

    createAnswer: function (onCreateAnswerSuccess, onCreateAnswerError) {
        var self = this;

        _logger.info('createAnswer start',  self.closed, self.sdpConstraints);
        // Since the 'remote' side has no media stream we need
        // to pass in the right constraints in order for it to
        // accept the incoming offer of audio and video.
        return self._rtcPeerConnection.createAnswer(self.sdpConstraints).then(
            function (desc) {
                _logger.debug('_____________________Answer ', self._rtcId, self.__id,  self.closed);//_logger.debug('from :\n' + desc.sdp);

                desc.type = 'answer';

                function updateSDP(sdpSection) {
                    var ms = sdpSection.parseMsidSemantic(sdpSection.headerSection);
                    if(!ms){
                        return;
                    }

                    if(ms.WMS == '*') {
                        sdpSection.updateHeaderMsidSemantic(ms.WMS = "MS_0000");
                    }
                    var audioSSRC = sdpSection.parseSSRC(sdpSection.audioSection);
                    var videoSSRC = sdpSection.parseSSRC(sdpSection.videoSection);

                    audioSSRC && sdpSection.updateAudioSSRCSection(1000, "CHROME0000", ms.WMS, audioSSRC.label || "LABEL_AUDIO_1000");
                    if(videoSSRC){
                        sdpSection.updateVideoSSRCSection(2000, "CHROME0000", ms.WMS, videoSSRC.label || "LABEL_VIDEO_2000");
                    }
                    // mslabel cname

                    desc.sdp = sdpSection.getUpdatedSDP();
                }

                var sdpSection = new SDPSection(desc.sdp, self);
                self.optimalVideoCodecs && sdpSection.updateVCodes(self.optimalVideoCodecs);
                self.optimalAudioCodecs && sdpSection.updateACodes(self.optimalAudioCodecs);

                if(emedia.supportPRAnswer){
                    updateSDP(sdpSection);
                }else{
                    desc.sdp = sdpSection.getUpdatedSDP(); //保持顺序
                }

                self.__answerDescription = desc;

                _logger.debug('Answer ', self._rtcId, self.__id,  self.closed);//_logger.debug('from :\n' + desc.sdp);
                _logger.debug('setLocalDescription start', desc, self._rtcId, self.__id,  self.closed);

                self._rtcPeerConnection.setLocalDescription(desc).then(
                    self._onSetLocalSessionDescriptionSuccess.bind(self),
                    self._onSetSessionDescriptionError.bind(self, desc)
                ).then(function () {
                    if(emedia.supportPRAnswer){
                        sdpSection.updateHeaderMsidSemantic("MS_0000");
                        sdpSection.updateAudioSSRCSection(1000, "CHROME0000", "MS_0000", "LABEL_AUDIO_1000");
                        sdpSection.updateVideoSSRCSection(2000, "CHROME0000", "MS_0000", "LABEL_VIDEO_2000");

                        desc.sdp = sdpSection.getUpdatedSDP();
                    }

                    _logger.debug('Send Answer ', self._rtcId, self.__id, self.closed);//_logger.debug('from :\n' + desc.sdp);

                    self.cctx && (desc.cctx = self.cctx);
                    (onCreateAnswerSuccess || self.onCreateAnswerSuccess.bind(self))(desc);
                });
            },
            (onCreateAnswerError || self._onCreateSessionDescriptionError.bind(self, self.sdpConstraints))
        );
    },

    _printStats: function(mediaStream){
        var self = this;
        if(!self.confrAttendee || !emedia.config.remainLastStatsCount){
            return;
        }

        mediaStream && mediaStream.getTracks().forEach(function (track) {
            self._printTrackStats(track);
        })
    },

    _printTrackStats: function(track){
        var self = this;
        if(!self.confrAttendee || !emedia.config.remainLastStatsCount){
            return;
        }

        var trackStats = self.confrAttendee._trackStats && self.confrAttendee._trackStats[track.id];
        if(!trackStats){
            return;
        }

        for(var type in trackStats){
            var typeStats = trackStats[type];

            for(var subType in typeStats){
                var stats = typeStats[subType];

                if(!stats){
                    continue;
                }

                var index = stats.curIndex;
                for(var i = 0; i < emedia.config.remainLastStatsCount; i++){
                    index = (index - 1) % emedia.config.remainLastStatsCount;
                    var stat = stats[index];
                    if(!stat || stat.data === undefined){
                        break;
                    }
                    _logger.info("[track]", self._rtcId, self.__id, track.kind, track.id, type, subType, stat.data, stat.timestamp.toLocaleString());
                }
            }
        }

        _util.removeAttribute(self.confrAttendee._trackStats, track.id);
    },

    close: function (remainLocalStream, onlyPeerConnectionClosed, retryBuild) {
        var self = this;
        _logger.warn("webrtc closing",  self._rtcId, self.__id, self.closed);

        self.__iceWaitIntervalId && clearTimeout(self.__iceWaitIntervalId);

        if(self.closed){
            return;
        }

        onlyPeerConnectionClosed = (onlyPeerConnectionClosed === true);

        self.closed = true;

        try {
            //self._rtcPeerConnection && self._rtcPeerConnection.close();
            var localStream = self._localStream;
            var remoteStream = self._remoteStream;

            function closePC() {
                self._rtcPeerConnection && self._rtcPeerConnection.close();
                _logger.info("peer connection close. it is", self._rtcPeerConnection && self._rtcPeerConnection.__peerId);

                if(!retryBuild && emedia.isSafari){ //safari close peer connection, not notify state closed
                    var theState = self._rtcPeerConnection.iceConnectionState || self._rtcPeerConnection.connectionState;
                    setTimeout(function () {
                        var nowState = self._rtcPeerConnection.iceConnectionState || self._rtcPeerConnection.connectionState;
                        // if(nowState !== 'closed' && theState !== 'closed'){
                        //     self.onIceStateChange && self.onIceStateChange('closed');
                        // }
                        self.onIceStateChange && self.onIceStateChange('closed');
                    }, 200);
                }
            }

            if(emedia.config.printStatsWhenPCClose){
                self.getStats(()=>{
                    closePC();

                    localStream && self._printStats(localStream);
                    remoteStream && self._printStats(remoteStream);
                });
            }else{
                closePC();
            }
        } catch (e) {
            _logger.warn(e);
        } finally {
            if(self._localStream && remainLocalStream === false){ //localstream存在，不保留localstream
                emedia.stopTracks(self._localStream);
            }

            if (self._remoteStream) {
                emedia.stopTracks(self._remoteStream);
            }
            self._remoteStream = null;

            if(!onlyPeerConnectionClosed){
                self.onClose && self.onClose();
            }

            if(retryBuild === true){
                _logger.info("Webrtc close. but retry build. will onIceStateChange(failed). eg. emedia.config iceWaitBuildMillis", self._rtcId, self.__id);
                self.onIceStateChange && self.onIceStateChange('failed');
            }

            _logger.warn("webrtc closed. closed:", self._rtcId, self.__id, self.closed);
        }
    },

    addIceCandidate: function (candidate) {
        console.log('addIceCandidate candidate', JSON.stringify(candidate));

        var self = this;

        var _cands = _util.isArray(candidate) ? candidate : [candidate];

        if(emedia.mgr.rtc_url_config) {// 读取rtcconfig 替换cands 如果开启了使用多集群
            _cands = emedia.mgr.rtc_url_config.replace_candidates(_cands);
        }

        if(emedia && emedia.config && (typeof emedia.config.reChanageCandidate === "function")){
            var candsChanaged = [];
            for (var i = 0; i < _cands.length; i++) {
                candidate = _cands[i];

                var newCandidates = emedia.config.reChanageCandidate(candidate);
                if(newCandidates){
                    _logger.info("Candidate rechanage. addons. it =", candidate, "->", newCandidates);

                    if(_util.isArray(newCandidates)){
                        Array.prototype.push.apply(candsChanaged, newCandidates);
                    }else{
                        candsChanaged.push(newCandidates);
                    }
                }
            }
            _cands = candsChanaged;
        }

        self._addIceCandidate(_cands);
    },

    _addIceCandidate: function (candidate) {
        var self = this;

        if (!self._rtcPeerConnection) {
            return;
        }

        _logger.debug('Add ICE candidate: ', candidate, self._rtcId, self.__id,  self.closed);

        var _cands = _util.isArray(candidate) ? candidate : [candidate];
        //!_util.isArray(candidate) && _cands.push(candidate);

        if(!self.__setRemoteSDP){
            Array.prototype.push.apply((self.__tmpRemoteCands || (self.__tmpRemoteCands = {})), _cands);

            _logger.debug('Add ICE candidate but tmp buffer caused by not set remote sdp: ', candidate, self._rtcId, self.__id,  self.closed);
            return;
        }

        for (var i = 0; i < _cands.length; i++) {
            candidate = _cands[i];

            if(candidate.cctx && candidate.cctx != self.cctx){
                _logger.warn('addIceCandidate fail drop. cctx not equal. ', candidate, self._rtcId, self.__id,  self.closed);
                continue;
            }

            //candidate.candidate = candidate.candidate.replace("172.17.2.130", "10.121.63.1");
            if(self.fireFoxOfferVideoPreAudio === true){
                //candidate.sdpMid = "sdparta_0";
                var oldLineIndex = candidate.sdpMLineIndex;
                candidate.sdpMLineIndex = parseInt(candidate.sdpMid.replace(/[^0-9]*/, ''));
                _logger.warn("Firefox sdp section video pre audio, sdp mline index update ", oldLineIndex, "->", candidate.sdpMLineIndex);
            }

            if(candidate.candidate && candidate.candidate !== ""){
                self._rtcPeerConnection.addIceCandidate(new RTCIceCandidate(candidate)).then(
                    self.onAddIceCandidateSuccess.bind(self),
                    self._onAddIceCandidateError.bind(self, candidate)
                );
            }else{
                _logger.warn("Add ICE candidate fail. drop it ", candidate, self._rtcId, self.__id,  self.closed);
            }
        }
    },

    setRemoteDescription: function (desc) {
        var self = this;
        //setTimeout(self._setRemoteDescription.bind(this, desc), 1000);
        return self._setRemoteDescription(desc);
    },

    _setRemoteDescription: function (desc) {
        var self = this;

        if(self.__iceWaitIntervalId){
            clearTimeout(self.__iceWaitIntervalId);
            self.__iceWaitIntervalId = null;
            _logger.info("emedia.config iceWaitBuildMillis, clear ice wait interval id", self._rtcId, self.__id);
        }

        _logger.debug('setRemoteDescription start. ', self._rtcId, self.__id,  self.closed);

        // 生成offer的
        // 会议模式，也是设置的是 pranswer 和 answer 会有服务器传回。
        // p2p模式下的主叫。此时设置的是 pranswer 和 answer。这个应该有p2p模式下传回。因此，需要如果有的话，需要判断
        if(self.offerDescription){
            if(desc.cctx && desc.cctx != self.cctx){
                _logger.warn('setRemoteDescription fail drop. cctx not equal. ', desc, self._rtcId, self.__id,  self.closed);
                return;
            }

            if(self.fireFoxOfferVideoPreAudio === true || self.__offerVideoPreAudio === true){
                //_logger.debug("Remote sdp.1", desc.sdp);

                var sdpSection = new SDPSection(desc.sdp, self);
                desc.sdp = sdpSection.getUpdatedSDP(false);
                _logger.info("Remote sdp.2. switch audio video", desc.sdp);
            }
        }else{//被叫 p2p模式，覆盖
            desc.cctx && (self.cctx = desc.cctx);
        }

        desc.sdp = desc.sdp.replace(/UDP\/TLS\/RTP\/SAVPF/g, "RTP/SAVPF");
        _logger.warn('setRemoteDescription. UDP/TLS/RTP/SAVPF -> RTP/SAVPF; if firefox: switch audio video;', self._rtcId, self.__id);
        //_logger.debug('setRemoteDescription.', desc, self._rtcId, self.__id);

        // https://webrtchacks.com/limit-webrtc-bandwidth-sdp/
        // bitrate
        if(self.vbitrate || self.abitrate || self.vminBitrate){
            var sdpSection = new SDPSection(desc.sdp, self);

            self.vbitrate && sdpSection.setVideoBitrate(self.vbitrate);
            self.vminBitrate && sdpSection.setVideoMinBitrate(self.vminBitrate);
            self.abitrate && sdpSection.setAudioBitrate(self.abitrate);

            _logger.warn("vbitrate = ", self.vbitrate, "vminBitrate = ", this.vminBitrate, ", abitrate = ", self.abitrate, self._rtcId, self.__id);
            desc.sdp = sdpSection.getUpdatedSDP(
                ((typeof self.__offerVideoPreAudio === 'undefined') || self.__offerVideoPreAudio === null) ? undefined : !self.__offerVideoPreAudio);
        }

        _logger.debug("final remote sdp =", desc.sdp, self._rtcId, self.__id);

        desc = self.__remoteDescription = new RTCSessionDescription(desc);

        return self._rtcPeerConnection.setRemoteDescription(desc).then(
            function() {
                self.__setRemoteSDP = true;
                self._onSetRemoteSuccess.apply(self, arguments);

                if(self.__tmpLocalCands && self.__tmpLocalCands.length > 0){
                    _logger.debug('After setRemoteDescription. send cands', self._rtcId, self.__id,  self.closed);
                    self._onIceCandidate(self.__tmpLocalCands);

                    self.__tmpLocalCands = [];
                }

                if(self.__tmpRemoteCands && self.__tmpRemoteCands.length > 0){
                    _logger.debug('After setRemoteDescription. add tmp cands', self._rtcId, self.__id,  self.closed);
                    self._addIceCandidate(self.__tmpRemoteCands);

                    self.__tmpRemoteCands = [];
                }
            },
            self._onSetSessionDescriptionError.bind(self, desc)
        );
    },

    iceConnectionState: function () {
        var self = this;

        return self._rtcPeerConnection.iceConnectionState;
    },

    isConnected: function () {
        var self = this;

        var state = self.lastIceConnectionState;

        return "connected" === state || "completed" === state;
    },

    _onGotRemoteStream: function (event) {
        var self = this;

        self._remoteStream = event.stream || event.streams[0];
        self._remoteStream._rtcId = self._rtcId;
        self._remoteStream.__rtc_c_id = self.__id;
        _logger.debug('On got remote stream',
            self._remoteStream ? self._remoteStream.id + "_" + self._remoteStream.active : "null",
            self._rtcId, self.__id);

        self._remoteStream && self._remoteStream.getTracks().forEach(function(track) {
            // if(typeof track.getSettings === 'function'){
            //     _logger.debug('remote stream', self._remoteStream.id,
            //         " track setting =", track.enabled, track.id, track.kind, track.label, track.getSettings(), self._rtcId, self.__id);
            // }else{
                _logger.debug('remote stream', self._remoteStream.id,
                    " track =", track.enabled, track.id, track.kind, track.label, self._rtcId, self.__id);
            // }
        });

        self.updateRemoteBySubArgs();

        this.onGotRemoteStream(this._remoteStream, event);

        _logger.debug('received remote stream, you will see the other.', self._rtcId, self.__id,  this.closed);
    },

    _onSetRemoteSuccess: function () {
        _logger.info('onSetRemoteSuccess success', this._rtcId, this.__id);
        this.onSetRemoteSuccess.apply(this, arguments);

        if(this.offerDescription && this.__remoteDescription && this.__remoteDescription.sdp){
            this._onAnswerCodes(this.__remoteDescription.sdp);
        }
    },

    _onAnswerCodes: function (sdp) {
        var self = this;
        var section = new SDPSection(sdp, this);
        if(section.videoSection){
            var rtpParams = SDPUtils.parseRtpParameters(section.videoSection);

            if(!rtpParams.codecs || rtpParams.codecs.length === 0){
                _logger.info("not found any video codes. @ ", self._rtcId, self.__id);
                return;
            }

            var vcodes = [];
            var flag = {};
            _util.forEach(rtpParams.codecs, function (_i, _param) {
                if(flag[_param.name] !== true){
                    flag[_param.name] = true;
                    vcodes.push(_param.name);
                }
            });

            self.finalVCodeChoices = vcodes;

            self.onVCodeChoices && self.onVCodeChoices(vcodes);
        }
    },

    onSetRemoteSuccess: function () {
    },

    onAddIceCandidateSuccess: function () {
        _logger.debug('addIceCandidate success', this._rtcId, this.__id);
    },

    _onAddIceCandidateError: function (candidate, error) {
        _logger.error('failed to add ICE Candidate: ' + error.toString(), ", error candidate:", candidate, this._rtcId, this.__id);
        this.onAddIceCandidateError(error);
    },
    onAddIceCandidateError: function (error) {
    },

    _onIceCandidate: function (candidate) {
        _logger.debug('onIceCandidate:', candidate, this._rtcId, this.__id);
        this.onIceCandidate(candidate);
    },
    onIceCandidate: function (candidate) {
    },

    onIceStateChange: function (state) {
        _logger.debug('onIceStateChange : ICE state ', state);
    },

    _onCreateSessionDescriptionError: function (offerOptionsOrSDPConstraints, error) {
        _logger.error('Failed to create session description: ' + error.toString(), " offerOptionsOrSDPConstraints:", offerOptionsOrSDPConstraints, this._rtcId, this.__id);
        this.onCreateSessionDescriptionError(error);
    },
    onCreateSessionDescriptionError: function (error) {
    },

    onCreateOfferSuccess: function (desc) {
        _logger.debug('create offer success', this._rtcId, this.__id);
    },

    onCreatePRAnswerSuccess: function (desc) {
        _logger.debug('create answer success', this._rtcId, this.__id);
    },

    onCreateAnswerSuccess: function (desc) {
        _logger.debug('create answer success', this._rtcId, this.__id);
    },

    _onSetSessionDescriptionError: function (sdp, error) {
        _logger.error('onSetSessionDescriptionError : Failed to set session description: ', error.toString(), this._rtcId, this.__id);
        sdp && sdp.type && sdp.sdp && _logger.error('error sdp: type=', sdp.type, "sdp=", sdp.sdp, this._rtcId, this.__id);
        this.onSetSessionDescriptionError(error);
    },
    onSetSessionDescriptionError: function (error) {
    },
    _onSetLocalSessionDescriptionSuccess: function () {
        var self = this;
        _logger.debug('onSetLocalSessionDescriptionSuccess : setLocalDescription complete', this._rtcId, this.__id);

        if(emedia.config.iceWaitBuildMillis){
            this.__iceWaitIntervalId && clearTimeout(this.__iceWaitIntervalId);
            this.__iceWaitIntervalId = setTimeout(function () {
                _logger.info("emedia.config iceWaitBuildMillis, timeout, will close webrtc, will retry build by onIceStateChange(failed)",
                    self._rtcId, self.__id);
                //self.close(true, true, true);
                self.onIceStateChange && self.onIceStateChange('failed');
            }, emedia.config.iceWaitBuildMillis);
            _logger.info("emedia.config iceWaitBuildMillis, start timeout", self._rtcId, self.__id);
        }

        this.onSetLocalSessionDescriptionSuccess();

        if(this.__answerDescription && this.__answerDescription.sdp){
            this._onAnswerCodes(this.__answerDescription.sdp);
        }
    },
    onSetLocalSessionDescriptionSuccess: function () {

    },

    onGotRemoteStream: function(remoteStream){
        _logger.debug("Got remote stream. ", remoteStream, this._rtcId, this.__id);
    },

    getStats: function (onCallback) {
        var self = this;

        if(!self._rtcPeerConnection){
            _logger.warn("Get stats, but peer connection not exsits, ", this._rtcId, this.__id);
            onCallback && onCallback();
            return;
        }

        if(typeof emedia.config.rtcStatsTypeMath !== 'function'){
            _logger.warn("Get stats, but config rtcStatsTypeMather, ", this._rtcId, this.__id);
            onCallback && onCallback();
            return;
        }

        self._rtcPeerConnection
            .getStats(null)
            .then(function (stats) {
                stats.forEach(function(_stat, name){
                    if(emedia.config.rtcStatsTypeMath(_stat, name)){
                        _logger.info("Rtc stats", _stat, self._rtcId, self.__id);
                    }
                });
                onCallback && onCallback(stats);
            })
    }
});

module.exports = _WebRTC;
